const openModal = document.querySelectorAll("[data-modal-id]");
const modal = document.querySelectorAll(".modal");
const body = document.body;

openModal.forEach((e) => {
    //open modal by id
    const modalId = document.querySelector("#" + e.dataset.modalId);
    e.addEventListener("click", () => {
        modalId.showModal();
        body.style.overflow = "hidden";
    });
});

modal.forEach((e) => {
    //close modal on button
    const closeBtn = e.querySelector("[data-modal='close']");
    closeBtn.addEventListener("click", () => {
        body.removeAttribute("style");
        closeModal(e);
    });

    //close modal on modalBody
    const modalBody = e.querySelector(".modal-body");
    modalBody.addEventListener("click", (a) => {
        if (a.target == modalBody) {
            body.removeAttribute("style");
            closeModal(e);
        }
    });

    //close modal on backdrop
    // e.addEventListener("click", (a) => {
    //     if (a.target.nodeName === "DIALOG") {
    //         closeModal(e);
    //     }
    // });
});

const closeModal = (e) => {
    //close modal function
    e.setAttribute("closing", "");
    e.addEventListener(
        "animationend",
        () => {
            e.removeAttribute("closing");
            e.close();
        },
        { once: true }
    );
};
//enable scrolling if modal is closed via espace
document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        document.body.style.overflow = '';
    }
});